/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g _stroke="#979797" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M1.404 1.404l9.546 9.546M10.596 1.404L1.05 10.95"/></g>'
  }
})
